import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import TitleBlock from '../TitleBlock';

const useStyles = makeStyles(theme => ({
  divider: {
    marginBottom: theme.spacing(2),
  },
  heading: {
    display: 'flex',
  },
  title: {
    flexGrow: 1,
  },
}));

export function EditLayoutHeader({ title, subtitle, actions }) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.heading}>
        <TitleBlock className={classes.title} title={title} subtitle={subtitle} />
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>
      <Divider className={classes.divider} />
    </>
  );
}

EditLayoutHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  actions: PropTypes.object,
};

export default memo(EditLayoutHeader);
